import React, { FunctionComponent, useMemo } from 'react';

import { CSSObject } from '@emotion/core';
import Flex, { FlexProps } from '@gojob/ui-bits/Flex';

import Header from 'src/components/Header';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Footer from 'src/components/Footer';

export interface WithLayoutProps extends FlexProps<'div'> {
  fullWidth?: boolean;
  maxWidth?: number | string;
}

const useStyles = (maxWidth?: number | string) => {
  const { breakpoint } = useTheme();
  return {
    main: {
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: maxWidth || breakpoint.values.md,
    },
  } as CSSObject;
};

const WithLayout: FunctionComponent<WithLayoutProps> = (props) => {
  const { children, maxWidth, fullWidth, ...other } = props;

  const classes = useStyles(maxWidth);

  const padding = useMemo(() => {
    if (fullWidth) {
      return { xs: [12, 0, 4], md: [12, 0, 4] };
    }
    return { xs: [12, 2, 4], md: [12, 4, 4] };
  }, [fullWidth]);

  return (
    <Flex flexDirection="column" alignItems="center" flex="1 0 auto" {...other}>
      <Header />
      <Flex
        as="main"
        css={classes.main}
        minHeight="100vh"
        flex="1 0 auto"
        padding={padding}
        justifyContent="center"
      >
        {children}
      </Flex>
      <Footer />
    </Flex>
  );
};

export default WithLayout;
